export const formatDate = (date: Date | string): string => {
  const d = typeof date === 'string' ? new Date(date) : date;
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${days[d.getDay()]}, ${d.getDate()} ${months[d.getMonth()]}`;
};

export const formatTime = (date: Date | string): string => {
  const d = typeof date === 'string' ? new Date(date) : date;
  const hour = d.getHours();
  const minute = d.getMinutes().toString().padStart(2, '0');
  const period = hour >= 12 ? 'PM' : 'AM';
  const displayHour = hour % 12 === 0 ? 12 : hour % 12;
  return `${displayHour}:${minute} ${period}`;
};

export const formatDateTime = (date: Date | string): string => {
  return `${formatDate(date)} • ${formatTime(date)}`;
};

export const isWithinWindow = (from: string, minutes = 30): boolean => {
  const sessionTime = new Date(from).getTime();
  const now = Date.now();
  const diff = (sessionTime - now) / 60000;
  return diff <= minutes && diff >= -60;
};

export const CurrencyFormatter = {
  ghana: (amount: number): string => {
    return `GHS ${amount.toFixed(2)}`;
  },
  zambia: (amount: number): string => {
    return `ZMW ${amount.toFixed(2)}`;
  },
  dollar: (amount: number): string => {
    return `USD ${amount.toFixed(2)}`;
  },
  format: (amount: number, country?: string): string => {
    switch (country) {
      case 'Ghana': return CurrencyFormatter.ghana(amount);
      case 'Zambia': return CurrencyFormatter.zambia(amount);
      default: return CurrencyFormatter.dollar(amount);
    }
  },
};
